exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-d8bfe640],h2[data-v-d8bfe640]{font-weight:400}header[data-v-d8bfe640]{width:100%;float:left;margin-top:20px;margin-bottom:30px}header img.logo1[data-v-d8bfe640]{width:80px;margin-left:20px;float:left}header img.logo2[data-v-d8bfe640]{height:80px;margin-right:20px;float:right}nav[data-v-d8bfe640]{display:inline-block;font-size:14px}nav a[data-v-d8bfe640]{color:#989898}nav a[data-v-d8bfe640]:before{content:\"\\F015\";font:normal normal normal 14px/1 FontAwesome;margin-right:6px}nav span.breadcrumb-separator[data-v-d8bfe640]:after{color:#989898;content:\"\\F105\";font:normal normal normal 14px/1 FontAwesome;padding:0 6px}@media (max-width:520px){header[data-v-d8bfe640]{margin-bottom:20px}header img.logo1[data-v-d8bfe640]{width:50px}header img.logo2[data-v-d8bfe640]{height:50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8bfe640","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PageHeader.vue
// module id = 20
// module chunks = 4